const myScoreQueryKeys = {
  all: ['all', 'myScore'] as const,
  widgetMyScoreLists: () => [...myScoreQueryKeys.all, 'widgetMyScoreList'] as const,
  widgetMyScoreList: (dateFrom: string) => [...myScoreQueryKeys.widgetMyScoreLists(), { dateFrom }] as const,
}

export default myScoreQueryKeys
